import { OBSERVATION_TYPE } from "../../utils/constants/observations";
import { toLocalISODate } from "../../utils/helpers/dateDisplay";

// The «Провести» action's look, shared by every surface that offers it.
// Conducting is the only action that CLOSES a booked visit, so it carries the
// app's one accent — but only once the day has arrived. A solid indigo button
// on a visit three weeks out competes with the ones that are actually owed,
// which is the distinction the overdue pile is made of.
export const CONDUCT_BTN = "bg-indigo-600 text-white hover:bg-indigo-700";
export const CONDUCT_SOON_BTN =
  "bg-white border border-indigo-200 text-indigo-700 hover:bg-indigo-50 hover:border-indigo-300";

export const CONDUCT_ICON_PATH = "M13 7l5 5m0 0l-5 5m5-5H6";

// Both are plain YYYY-MM-DD, so this compares calendar days, not instants. An
// undated visit counts as due — no future date is holding it back.
export const isConductDue = (scheduledDate, todayISO = toLocalISODate(new Date())) =>
  !scheduledDate || scheduledDate <= todayISO;

// A peer visit the colleague has not accepted yet is not the observer's to walk
// into — the Upcoming tab's AWAITING state. The server would take it; this is
// the product's rule. Officials carry no confirmation step.
export const awaitsPeerConfirmation = (visit) =>
  visit.type === OBSERVATION_TYPE.PEER && !visit.confirmed_at;
